module.exports = __webpack_public_path__ + "static/img/mk-1.d7d85b69.svg";